module.exports = __webpack_public_path__ + "img/Vapaus-logo-white.d9cccb1b.svg";